var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E8EE",
    d: "M14.545 20H2.995c-.8 0-1.552-.311-2.118-.877A2.98 2.98 0 0 1 0 17.005V2.995c0-.8.311-1.552.877-2.118A2.98 2.98 0 0 1 2.995 0h8.716l5.829 6.411v10.594c0 .8-.312 1.552-.877 2.118a2.98 2.98 0 0 1-2.118.877"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6F7B8D",
    d: "M13.147 6.411h4.393L11.71 0v4.975c0 .793.643 1.436 1.436 1.436"
  })));
};
export default SvgFile;